module.exports = __webpack_public_path__ + "img/icon-check.5742160c.svg";